<script lang="ts">

    import 'photo-sphere-viewer/dist/photo-sphere-viewer.css';
    import { Viewer } from 'photo-sphere-viewer';
    import { createEventDispatcher, onMount } from 'svelte';
    import type { Image360Activity } from '../../Model/Image360Activity';
    import ActiviyModal from '../Shared/ActiviyModal.svelte';
    import WinScreen from '../Shared/WinScreen.svelte';
    import { addPoints } from '../../Services/game';

    export let activity:Image360Activity;

    const dispatch = createEventDispatcher();

    let viewerContainer: HTMLElement;
    let showWinScreen = false;

    onMount(() => {

        new Viewer({
            container: viewerContainer,
            panorama: activity.image,
            navbar: [
                'autorotate',
                'zoom',
                'fullscreen',
            ],
        });

    });

    function onClose(): void {
        if (activity.isCompleted.value) {
            dispatch('close');
            return;
        }
        activity.setCompleted();
        addPoints(activity.points.win);
        showWinScreen = true;
    }

    function onContinue(): void {
        dispatch('close');
    }

</script>

<ActiviyModal on:close={onClose} title={activity.title}>
    <div class="viewer-container" bind:this={viewerContainer}></div>
</ActiviyModal>

{#if showWinScreen}
    <WinScreen points={activity.points.win} on:continue={onContinue} />
{/if}

<style lang="scss">

    .viewer-container {
        width: 100%;
        height: 100%;
    }

</style>
